import { getUrlParameter } from '../../admin/actions'

/**
 * Get logged user from query parameters
 *
 * @return {Object|null}
 */
export default () => {
    let loggedUserParams = null

    if (getUrlParameter('access_token')) {
        loggedUserParams = {
            access_token: getUrlParameter('access_token'),
        }

        if (getUrlParameter('refresh_token')) {
            loggedUserParams = {
                access_token: getUrlParameter('access_token'),
                refresh_token: getUrlParameter('refresh_token'),
                token_type: getUrlParameter('token_type'),
                expires_in: getUrlParameter('expires_in'),
            }
        }
    }

    return loggedUserParams
}

/**
 * Check if is access token inside url parameter
 *
 * @type {boolean}
 */
export const isAccessToken = !!getUrlParameter('access_token')
